module.exports = __webpack_public_path__ + "static/media/mute.cf146791.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/mute.mp3
// module id = 112
// module chunks = 0